import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 41.39 40.23" width="6em" height="6em" {...props}>
    <path
      d="M14.24 38.31c.17-.24.98-1.58 1.12-1.89l-.03.02.05-.04-.02.02a13.19 13.19 0 0 0 4.01-2.5c.53-.53 1.25-.9 1.94-1.23 1.05-.48 2.17-.82 3.23-1.3.98-.43 1.89-1.02 2.86-1.45 1.23-.54 2.5-.95 3.73-1.5.99-.44 1.92-1.01 2.9-1.5.48-.23.99-.41 1.63-.66 0-.56.02-1-.02-1.44-.02-.33-.17-.65-.27-.98-.5-1.55-.94-3.1-.93-4.76.01-.92-.28-1.84-.45-2.76L33 11.31c-.1-.49-.15-.98-.22-1.48l.03.04v.02L31.7 7.17a1.76 1.76 0 0 1-.16-.49c-.15-1.09-.28-2.18-.41-3.3-2.73 1.68-5.87.8-8.66 2-2.64 1.12-5.87.9-8.47 2.08-2.7 1.24-5.83.94-8.28 2.6l1.3 11.13c-.05 0-.08-.03-.13-.02.01.17.06.28.07.4l.12-.01.38 3.83c.01.08.01.15.09.33l.05.12 1.72 13.08c.26.7 2 .8 3.1.3.1-.04 1.66-.68 1.82-.9"
      fill="#303030"
    />
    <path
      d="M21.64 20.27h.46c-.08.66-.6 1.18-1.26 1.26v-.49a.16.16 0 0 0-.32 0v.5c-.67-.07-1.2-.6-1.28-1.27h.52a.16.16 0 1 0 0-.32h-.52c.07-.68.6-1.21 1.28-1.28v.31c0 .09.07.16.16.16s.16-.07.16-.16v-.31c.67.08 1.2.61 1.26 1.28h-.46a.16.16 0 1 0 0 .32m1.23-.32h-.44a1.77 1.77 0 0 0-1.59-1.61v-.4a.16.16 0 1 0-.32 0v.4c-.86.07-1.54.76-1.61 1.61h-.4a.16.16 0 1 0 0 .32h.4c.08.85.76 1.52 1.61 1.6v.45a.16.16 0 1 0 .32 0v-.46a1.79 1.79 0 0 0 1.6-1.59h.43a.16.16 0 0 0 0-.32"
      fill="currentColor"
    />
    <path
      d="M23.47 20.27h.45a3.25 3.25 0 0 1-3.08 3.08v-.45a.16.16 0 0 0-.32 0v.45a3.25 3.25 0 0 1-3.08-3.08h.46a.16.16 0 1 0 0-.32h-.46c.08-1.66 1.42-3 3.08-3.08v.46a.16.16 0 0 0 .32 0v-.46c1.67.08 3 1.42 3.08 3.08h-.45a.16.16 0 1 0 0 .32m.77-.32a3.57 3.57 0 0 0-3.4-3.4v-.94h-.32v.94a3.57 3.57 0 0 0-3.4 3.4h-.93v.32h.93a3.57 3.57 0 0 0 3.4 3.4v.95h.32v-.94a3.57 3.57 0 0 0 3.4-3.4h.95v-.33z"
      fill="currentColor"
    />
    <path
      d="M21.64 20.27h.46c-.08.66-.6 1.18-1.26 1.26v-.49a.16.16 0 1 0-.32 0v.5c-.67-.07-1.2-.6-1.28-1.27h.52a.16.16 0 1 0 0-.32h-.52c.07-.68.6-1.21 1.28-1.28v.31a.16.16 0 1 0 .32 0v-.31c.67.08 1.2.61 1.26 1.28h-.46a.16.16 0 1 0 0 .32m1.23-.32h-.44a1.77 1.77 0 0 0-1.59-1.61v-.4a.16.16 0 1 0-.32 0v.4c-.86.07-1.54.76-1.61 1.61h-.4a.16.16 0 1 0 0 .32h.4c.08.85.76 1.52 1.61 1.6v.45a.16.16 0 1 0 .32 0v-.46a1.79 1.79 0 0 0 1.6-1.59h.43a.16.16 0 1 0 0-.32"
      fill="currentColor"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/bouton-lieu-1.svg